import { createBrowserRouter, Outlet } from 'react-router'
import { routes } from '@/router/routes.tsx'
import { LoginPage } from '@/pages/login-page.tsx'
import { ErrorPage } from '@/pages/error-page.tsx'
import { PrivateRoutes } from '@/router/PrivateRoutes.tsx'
import { AppLayout } from '@/components/layouts/AppLayout.tsx'
import { LogoutPage } from '@/pages/logout-page.tsx'
import { PageLayout } from '@/components/layouts/PageLayout.tsx'
import { HomePage } from '@/pages/home-page.tsx'
import { deferredBonusesRoutes } from '@/pages/deferred-bonuses'
import { invoicesAllocationRoutes } from '@/pages/invoices-allocation'
import { featureFlags } from '@/config/feature-flags'
import { NotificationsPage } from '@/pages/notifications-page.tsx'

const featureRoutes = [
  ...(featureFlags.invoicesAllocation ? [invoicesAllocationRoutes] : []),
  ...(featureFlags.deferredBonuses ? [deferredBonusesRoutes] : []),
]

export const router = createBrowserRouter([
  { path: routes.login, element: <LoginPage />, errorElement: <ErrorPage /> },
  { path: routes.logout, element: <LogoutPage />, errorElement: <ErrorPage /> },
  {
    element: <PrivateRoutes><AppLayout><Outlet /></AppLayout></PrivateRoutes>, errorElement: <ErrorPage />, children: [
      { index: true, element: <HomePage /> },
      { path: routes.notifications, element: <NotificationsPage /> },
      ...featureRoutes,
      { path: '*', element: <PageLayout>Page Not Found</PageLayout> },
    ],
  },
])